import React from "react";
import { Link, LinkProps } from "react-router-dom";
import { primaryClasses } from "./primary-button";
import { secondaryClasses, secondaryCompactClasses } from "./secondary-button";

const buttonLink = (buttonClasses: string): React.FC<LinkProps> => {
    const Component: React.FC<LinkProps> = ({ className, ...rest }) => (
        <Link className={`${className ?? ""} ${buttonClasses}`} {...rest} />
    );
    return Component;
};

export const PrimaryButtonLink = buttonLink(`items-center gap-1 ${primaryClasses}`);
PrimaryButtonLink.displayName = "PrimaryButtonLink";

export const SecondaryButtonLink = buttonLink(`items-center gap-1 ${secondaryClasses}`);
SecondaryButtonLink.displayName = "SecondaryButtonLink";

export const SecondaryCompactButtonLink = buttonLink(
    `items-center gap-1 ${secondaryCompactClasses}`,
);
SecondaryCompactButtonLink.displayName = "SecondaryCompactButtonLink";

export const PrimaryButtonAnchor: React.FC<
    React.AnchorHTMLAttributes<HTMLAnchorElement>
> = ({ className, ...rest }) => (
    <a className={`${className ?? ""} items-center gap-1 ${primaryClasses}`} {...rest} />
);
